package components.routing

object ApplicationRoutingUrls {
    object Unprotected {
        const val withOwner = "/:companyName"
    }

    object Protected {
        const val stockListPage = "/stock"
        const val inboundListPage = "/inbound"
        const val inboundDetailPage = "$inboundListPage/:recordId"
        const val outboundListPage = "/outbound"
        const val outboundDetailPage = "$outboundListPage/:recordId"
        const val deliveriesListPage = "/deliveries"
        const val deliveryDetailedPage = "$deliveriesListPage/:recordId"
    }
}